
import {
    SelectedFilters,
    ReactiveComponent
} from '@appbaseio/reactivesearch';
import { get, map } from 'lodash';
import ErrorBoundary from '../ErrorBoundary';
import ReactApexChart from 'react-apexcharts';
import getBarChartOptions from './ChartOptions/BarChartOptions';

const MLResultsBarChart = ({ componentId, type, interactiveIds }) => {
    let pass_agg = '';
    let fail_agg = '';
    if (type === 'train') {
        pass_agg = 'Train F1 Score - PASS LOT'
        fail_agg = 'Train F1 Score - FAIL LOT'
    } else {
        pass_agg = 'Test F1 Score - PASS LOT'
        fail_agg = 'Test F1 Score - FAIL LOT'
    }
    return (
        <ReactiveComponent
            componentId={componentId}
            defaultQuery={() => ({
                query: {
                    bool: {
                        must: [
                            {
                                range: {
                                    'length of input features': {
                                        lte: 3
                                    }
                                }
                            }
                        ],
                        must_not: [
                            {
                                terms: {
                                    sampling: ["over", "under"]
                                }
                            }
                        ]
                    }
                },
                aggs: {
                    data: {
                        terms: {
                            field: 'training features',
                            size: 1000
                        },
                        aggs: {
                            pass: {
                                avg: {
                                    field: pass_agg
                                },
                            },
                            fail: {
                                avg: {
                                    field: fail_agg
                                }
                            }
                        },
                    },
                },
                size: 0,
            })
            }
            URLParams
            showFilter
            react={interactiveIds}
            render={({ aggregations, ...rest }) => {
                let datakeys = [];
                let passValues = [];
                let failValues = [];
                const data = map(
                    get(aggregations, 'data.buckets'),
                    (b) => {
                        datakeys.push(b.key);
                        passValues.push(b.pass.value.toFixed(2));
                        failValues.push(b.fail.value.toFixed(2));
                    }
                );
                let indices = datakeys.map((_, index) => index);

                // Sort passValues in descending order and rearrange the indices array accordingly
                indices.sort((a, b) => passValues[b] - passValues[a]);

                // Rearrange the elements in datakeys, passValues, and failValues based on the sorted indices
                datakeys = indices.map(index => datakeys[index]);
                passValues = indices.map(index => passValues[index]);
                failValues = indices.map(index => failValues[index]);

                const dataSeries = [{ name: 'Pass', data: passValues }, { name: 'Fail', data: failValues }];

                const BarChartOptions = getBarChartOptions(datakeys);
                return (
                    <div className='chart'>
                        <ReactApexChart options={BarChartOptions} series={dataSeries} type="bar" height={450} />
                    </div>
                );
            }}
        />
    );
}

const MLResultsSamplingUnder3 = ({ interactiveIds }) => {
    return (
        <div className="container-fluid my-2">
            <div className="row g-2">
                <div className="col-12">
                    <div className="p-2 bg-white">
                        <div className="row">
                            <div className='col-12'>
                                <h5>Length of input feature upto 3</h5>
                            </div>
                        </div>
                        <div
                            className="border shadow-sm p-2 mb-2"
                            style={{ minWidth: '300px' }}
                        >
                            <div className="row">
                                <div className='col-12'><h5 style={{ textAlign: 'center' }}>Train F1 Scores for Training Features</h5>
                                    <ErrorBoundary>
                                        <MLResultsBarChart componentId="homeBarchartTrainU3" type="train" interactiveIds={interactiveIds} />
                                    </ErrorBoundary>
                                </div>
                            </div>
                            <hr />
                            <div className="row-1">
                                <div className='col-12'><h5 style={{ textAlign: 'center' }}>Test F1 Scores for Training Features</h5>
                                    <ErrorBoundary>
                                        <MLResultsBarChart componentId="homeBarchartTestU3" type="test" interactiveIds={interactiveIds} />
                                    </ErrorBoundary>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MLResultsSamplingUnder3;